<!-- 开局模式提示栏 -->
<div *ngIf="isInDeployment" class="deployment-mode-container">
    <div class="deployment-mode-dialog">
        <svg class="icon">
            <use xlink:href="#core-icon-simple-status-failed"></use>
        </svg>
        <!-- 告警内容 -->
        <span class="deployment-mode-content ml-8">{{deploymentModeWarningContent}}</span>
    </div>
    <!-- 结束开局 -->
    <button nButton *ngIf="isSuperAdmin" class="deployment-mode-container-end-btn"
        id="deployment-mode-end-btn" [loading]="btnLoading" [label]="i18n.endBtnLable"
        (click)="endRemoteDeployment()">
    </button>
</div>
